import React from 'react';
import { colors } from '../utils/theme';

// Período rápido (02/11/2026): Hoje, Ontem, 7/15/30 dias, Este mês, Mês
// anterior e Personalizado — o mesmo jeito de escolher período em qualquer
// consulta. As datas são do dia local (quem usa está no Brasil), em
// 'YYYY-MM-DD'.
export const PRESETS = [
  { v: 'hoje', label: 'Hoje' },
  { v: 'ontem', label: 'Ontem' },
  { v: '7d', label: '7 dias' },
  { v: '15d', label: '15 dias' },
  { v: '30d', label: '30 dias' },
  { v: 'mes', label: 'Este mês' },
  { v: 'mes_anterior', label: 'Mês anterior' },
  { v: 'livre', label: 'Personalizado' },
];

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export function intervaloDoPreset(preset, hoje = new Date()) {
  const d = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
  const menos = (n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() - n);
  switch (preset) {
    case 'ontem': return { de: iso(menos(1)), ate: iso(menos(1)) };
    case '7d': return { de: iso(menos(6)), ate: iso(d) };
    case '15d': return { de: iso(menos(14)), ate: iso(d) };
    case '30d': return { de: iso(menos(29)), ate: iso(d) };
    case 'mes': return { de: iso(new Date(d.getFullYear(), d.getMonth(), 1)), ate: iso(d) };
    case 'mes_anterior': return {
      de: iso(new Date(d.getFullYear(), d.getMonth() - 1, 1)),
      ate: iso(new Date(d.getFullYear(), d.getMonth(), 0)),
    };
    default: return { de: iso(d), ate: iso(d) };
  }
}

// value: { preset, de, ate } · onChange(novoValue)
export default function PeriodoRapido({ value, onChange, children }) {
  const escolher = (preset) => {
    if (preset === 'livre') onChange({ ...value, preset });
    else onChange({ preset, ...intervaloDoPreset(preset) });
  };
  const chip = (ativo) => ({
    padding: '6px 12px', borderRadius: 16, fontSize: 12, fontWeight: 600, cursor: 'pointer',
    border: `1px solid ${ativo ? colors.primary : colors.border}`,
    background: ativo ? `${colors.primary}22` : 'transparent',
    color: ativo ? colors.primary : colors.textMuted,
  });
  const campoData = {
    padding: '6px 10px', borderRadius: 8, border: `1px solid ${colors.border}`,
    background: colors.bg, color: colors.text, fontSize: 13, colorScheme: 'dark',
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      {PRESETS.map(p => (
        <button key={p.v} type="button" style={chip(value.preset === p.v)} onClick={() => escolher(p.v)}>{p.label}</button>
      ))}
      {value.preset === 'livre' && (
        <>
          <input type="date" value={value.de} max={value.ate} aria-label="De" style={campoData}
            onChange={e => onChange({ ...value, de: e.target.value })} />
          <span style={{ color: colors.textMuted, fontSize: 12 }}>até</span>
          <input type="date" value={value.ate} min={value.de} aria-label="Até" style={campoData}
            onChange={e => onChange({ ...value, ate: e.target.value })} />
        </>
      )}
      {children}
    </div>
  );
}
